/**
 * Routes tech-tests.
 *
 * @remarks
 * 3 niveaux de profondeur, chacun avec son `handle.context` :
 * - `/tests` → catalog
 * - `/tests/:testId` → détail test (timeline)
 * - `/tests/:testId/evaluation/:evaluationId` → workspace évaluation
 *
 * Note : `/tests/:testId/evaluation/:evaluationId/attempt/:attemptId`
 * (résultats d'analyse IA) sera porté par la feature `candidate-results`
 * en Phase 5.4.
 */

import { Outlet, type RouteObject } from 'react-router-dom';
import { CONTEXTS } from '@/app/registry';

export const techTestsRoutes: RouteObject[] = [
  {
    path: 'tests',
    Component: Outlet,
    handle: { context: CONTEXTS.TECH_TESTS_CATALOG, title: 'Tests techniques' },
  },
  {
    path: 'tests/:testId',
    Component: Outlet,
    handle: { context: CONTEXTS.TECH_TESTS, title: 'Aperçu du test' },
  },
  {
    path: 'tests/:testId/evaluation/:evaluationId',
    Component: Outlet,
    handle: { context: CONTEXTS.TECH_TEST_EVALUATION, title: 'Évaluation du test' },
  },
];
